<template>
  <v-card class="mx-auto" max-width="1000" min-width="300">
    <v-toolbar
      class="pencil"
      :color="ToolColor"
      dark
      @click="
        Loadin();
        Hide = !Hide;
      "
    >
      <v-toolbar-title>{{ Headline }}</v-toolbar-title>

      <v-toolbar-side-icon color="white darken-1">
        <v-icon v-if="Hide == false" color="orange ligthen-1"
          >arrow_downward</v-icon
        >
        <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
      </v-toolbar-side-icon>

      <v-spacer></v-spacer>
    </v-toolbar>

    <v-expand-transition>
      <div v-if="Hide">
        <div v-if="violations.length != 0">
          <div>
            <v-flex justify="center">
              <v-dialog v-model="dialogAccess" persistent max-width="600px">
                <v-toolbar color="yellow" dark>
                  <v-toolbar-title class="headline">
                    Bekräftelse av mottagande av kränkningsanmälan
                  </v-toolbar-title>
                </v-toolbar>
                <v-list>
                  Härmed så bekräftar du ({{
                    locfun.getName(id, [], membernameandId)
                  }}) i egenskap av rektor att du har tagit del av
                  kränkningsanmälan. Först när detta är bekräftat så kan anmälan
                  arkiveras.

                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    color="red darken-1"
                    @click="dialogAccess = false"
                  >
                    Stäng
                  </v-btn>
                  <v-btn
                    dark
                    color="blue darken-1"
                    @click="
                      approveViolation(removeItem);
                      dialogAccess = false;
                    "
                  >
                    Bekräfta
                  </v-btn>
                </v-list>
              </v-dialog>

              <v-dialog v-model="dialogInfo" persistent max-width="600px">
                <v-toolbar color="pink" dark>
                  <v-toolbar-title class="headline"> Händelse </v-toolbar-title>
                </v-toolbar>
                <v-list v-if="dialogInfo == true">
                  {{ removeItem.Answers[8] }}

                  <v-spacer></v-spacer>
                  <v-btn dark color="red darken-1" @click="dialogInfo = false">
                    Stäng
                  </v-btn>
                </v-list>
              </v-dialog>

              <ArchiveWindow
                Type="violation"
                :removeItem="removeItem"
                v-model="dialogArchive"
                Headline="Arkivera kränkningsanmälan"
                WarningText="Du arkvierar nu kränkningsanmälan, den kommer i framtiden gå att komma åt men inte ligga i kränkningsanmälningstabellen."
              />
              <RemoveWindow
                Type="violation"
                :removeItem="removeItem"
                v-model="dialogDelete"
                Headline="Ta bort kränkningsanmälan "
                WarningText="Är du säker på att du vill ta bort kränkningsanmälan från EHTKollen? En kränkningsanmälan som är
              borttagen går inte att återfå. Vi rekomenderar att rektor godkänner och arkiverar kränknignsanmälningar."
              />
            </v-flex>
            <v-text-field
              v-model="search"
              label="Sök efter kränkningsärende"
              class="mx-4"
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="
                archive == 'true'
                  ? violations.filter(
                      (C) => C.hasOwnProperty('archive') == true
                    )
                  : violations.filter(
                      (C) => C.hasOwnProperty('archive') == false
                    )
              "
              item-key="uploadDate"
              sort-by="name"
              class="elevation-1"
              :pagination.sync="pagination"
              :search="search"
              show-group-by
            >
              <template v-slot:items="props">
                <tr
                  :class="
                    props.item.hasOwnProperty('approved') ? 'approved' : ''
                  "
                >
                  <td
                    class="text-xs-right"
                    v-if="typeof props.item.Contact == 'string'"
                  >
                    {{
                      locfun.getName(
                        props.item.Contact,
                        teachernameandId,
                        membernameandId
                      )
                    }}
                  </td>
                  <td class="text-xs-right" v-else>
                    {{ props.item.Contact.Name }}
                  </td>

                  <td class="text-xs-right">
                    {{
                      props.item.hasOwnProperty("uploadDate")
                        ? locfun.getDate(props.item.uploadDate)
                        : "Ingen data att visa"
                    }}
                  </td>
                  <td class="text-xs-right">
                    {{ locfun.getDate(props.item.Answers[5]) }}
                    {{ locfun.getTime(props.item.Answers[5]) }}
                  </td>

                  <td class="text-xs-right">{{ props.item.Answers[4] }}</td>
                  <td class="text-xs-right">
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="props.item.Answers[0] == '1'"
                      >Mobbing</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="props.item.Answers[1] == '1'"
                      >Kränkande behandling</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="purple"
                      text-color="white"
                      v-if="props.item.Answers[2] == '1'"
                      >Diskriminering</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="blue"
                      text-color="white"
                      v-if="props.item.Answers[3] == '1'"
                      >Trakasserier</v-chip
                    >
                  </td>

                  <td class="text-xs-right">{{ props.item.Answers[6] }}</td>
                  <td class="text-xs-right">{{ props.item.Answers[7] }}</td>
                  <td
                    class="text-xs-right"
                    @click="
                      removeItem = props.item;
                      dialogInfo = true;
                    "
                  >
                    {{ props.item.Answers[8] }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.Answers[9] == 1 ? "Ja" : "Nej" }}
                  </td>
                  <td class="text-xs-right">
                    {{
                      props.item.Answers[10] == 1
                        ? props.item.Answers[11]
                        : "Nej"
                    }}
                  </td>

                  <td class="text-xs-right" v-if="role == 'rektor'">
                    <v-btn
                      v-if="!props.item.hasOwnProperty('approved')"
                      class="mx-2"
                      fab
                      dark
                      small
                      @click="
                        removeItem = props.item;
                        removeItem.name = '';
                        dialogAccess = true;
                      "
                      color="blue ligthen-1"
                    >
                      <v-icon dark> check </v-icon>
                    </v-btn>
                    <v-btn
                      v-else-if="C.hasOwnProperty('archive') == false"
                      class="mx-2"
                      fab
                      dark
                      small
                      @click="
                        removeItem = props.item;
                        removeItem.name = '';
                        dialogArchive = true;
                      "
                      color="green ligthen-1"
                    >
                      <v-icon dark> archive </v-icon>
                    </v-btn>
                  </td>

                  <td class="text-xs-right">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      small
                      @click="openItem = props.item;openViolation=true;"
                      color="green ligthen-1"
                    >
                      <v-icon dark> assignment_ind </v-icon>
                    </v-btn>
                  </td>

                  <td class="text-xs-right">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      small
                      @click="
                        removeItem = props.item;
                        removeItem.name = '';
                        dialogDelete = true;
                      "
                      color="red ligthen-1"
                    >
                      <v-icon dark> clear </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  Det finns inget resultat för din sökning på "{{ search }}".
                </v-alert>
              </template>
            </v-data-table>
            <div class="text-xs-center pt-2">
              <v-btn color="light-blue darken-1" dark @click="toggleOrder"
                >Ändra sorteringsordning</v-btn
              >
              <v-btn color="light-blue darken-1" dark @click="nextSort"
                >Sortera på nästa kolumn</v-btn
              >
            </div>
          </div>
        </div>
        <div
          v-else
          class="bellowPen"
          :class="ToolColor + ' lighten-3 text-center'"
        >
          <span class="tt" color="white"
            >Det finns inga kränkningsanmälningar.</span
          >
        </div>
      </div>
    </v-expand-transition>
    <v-dialog v-model="openViolation" persistent max-width="650px">
    <v-card  min-height="80vh" v-if="openItem!=null">
      <v-toolbar  color="green lighten-3" dark>
        <v-toolbar-title class="headline"
          >Kränkningsanmälan {{openItem.Contact == 'string'? locfun.getName(
                       openItem.Contact,
                        teachernameandId,
                        membernameandId
                      ):openItem.Contact.Name}}</v-toolbar-title
        >
      </v-toolbar>

    <v-card-text>
  <h4 id="head">Anmälare:      <span 
                    v-if="typeof openItem.Contact == 'string'"
                  >
                  {{
                      locfun.getName(
                       openItem.Contact,
                        teachernameandId,
                        membernameandId
                      )
                    }}
                  </span>
                  <span v-else>
                       {{ openItem.Contact.Name }}
                    Mail:  {{ openItem.Contact.Mail }}
                    Nummer:  {{ openItem.Contact.Number }}
                      <span  class="purple pa-1 br-1 text-xs-right" v-if="openItem.Contact.Feedback=='1'"> Önskar återkoppling.</span>
                  </span>  </h4>

  <h4 id="head">Tid:  {{ locfun.getDate(openItem.Answers[5]) }}
                    {{ locfun.getTime(openItem.Answers[5]) }} </h4>
  <h4 id="head">Plats: {{ openItem.Answers[4]}}</h4>
  <h4 id="head">Utövare: {{ openItem.Answers[6]}}</h4>
  <h4 id="head">Åskådare: {{ openItem.Answers[7]}}</h4>
  
 <h4 id="head">Typ:
  <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="openItem.Answers[0] == '1'"
                      >Mobbing</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="openItem.Answers[1] == '1'"
                      >Kränkande behandling</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="purple"
                      text-color="white"
                      v-if="openItem.Answers[2] == '1'"
                      >Diskriminering</v-chip
                    >
                    <v-chip
                      class="ma-2"
                      color="blue"
                      text-color="white"
                      v-if="openItem.Answers[3] == '1'"
                      >Trakasserier</v-chip
                    >
                    </h4>

                    
  <h4 id="head">Händelse:
     <span>{{ openItem.Answers[8]}} </span>
     </h4> 
  <h4 id="head">Är kränkningen pågående:  {{ openItem.Answers[9] == 1 ? "Ja" : "Nej" }}</h4>
  <h4 id="head">Direktkontakt med skolan: {{
                      openItem.Answers[10] == 1
                        ? openItem.Answers[11]
                        : "Nej"
                    }}</h4>
    </v-card-text>
            <v-btn color="red lighten-1" text dark @click="openViolation=false">
          Stäng
        </v-btn>
    </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import RemoveWindow from "../assets/RemoveWindow";
import ArchiveWindow from "../assets/ArchiveWindow.vue";
export default {
  name: "kränkrapport",
  components: {
    RemoveWindow,
    ArchiveWindow,
  },
  props: {
    // content: Array,
    role: String,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    id: String,
    archive: String,
  },

  watch: {},
  created() {
    //console.log(this.schoolId)
    this.locfun = new fun();
    if (this.role == "rektor")
      this.headers.push({ text: "Tagit del ", value: "ändra", align: "right" });

    this.headers.push({ text: "Detalj", value: "detail", align: "right" });
    this.headers.push({ text: "Ta bort", value: "tabort", align: "right" });
  },
  computed: {
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters("violations", ["violations", "violationsFetched"]),
  },
  methods: {
    ...mapActions("violations", ["initViolations", "approveViolation"]),

    Loadin() {
      if (this.violationsFetched == false) {
        //console.log("Fetched");
        this.initViolations(this.schoolId);
      }
    },
    toggleOrder() {
      this.pagination.descending = !this.pagination.descending;
    },
    nextSort() {
      let index = this.headers.findIndex(
        (h) => h.value === this.pagination.sortBy
      );
      index = (index + 1) % this.headers.length;
      index = index === 0 ? index + 1 : index;
      this.pagination.sortBy = this.headers[index].value;
    },

    ...mapActions("classesAP", ["removeAP", "saveAP"]),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      search: "",
      pagination: {
        sortBy: "steps[0].starttime",
      },
      openViolation: false,
      removeItem: { name: "temp", id: "temp" },
      openItem: null,
      accessItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogArchive: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogInfo: false,
      Class: null,
      Choosen: null,
      Hide: false,
      headers: [
        {
          text: "Anmälare",
          align: "start",
          value: "name",
        },
        { text: "Anmälningsdatum", value: "description", align: "right" },
        { text: "Tid", value: "link", align: "right" },
        { text: "Plats", value: "createDate", align: "right" },
        { text: "Typ", value: "uploader", align: "right" },
        { text: "Utövare", value: "uploader", align: "right" },
        { text: "Åskådare", value: "uploadDate", align: "right" },
        { text: "Händelse", value: "expireDate", align: "right" },
        { text: "Pågående", value: "reviewer", align: "right" },
        { text: "Tidigare kontakt", value: "ändra", align: "right" },
      ],
    };
  },
};
</script>

<style>
#head{
  background-color: #2E7D32;
  margin: 20px !important;
  color:white;
  border-radius: 10px;
}
.approved {
  background-color: lightcyan !important;
  /* color:blue; */
}
</style>
